import { changeActivity, openNextSubtema } from "./menu";

export const completeOneTask = (payload) => {
	return async (dispatch, getState) => {
		const state = getState();
		const { idActivity, pointsWin, subtema } = payload;
		let idToNextOpen = 0;
		let nextSubtemaOpen = "none";
		let numberOfTaskCompleted = 0;

		//* si es que se manda otro id
		if (state.menu.activitiesInformation[subtema] === undefined) {
			console.log("no existe para guardar puntaje");
			return;
		}

		let activitiesInformationUpdated = state.menu.activitiesInformation[subtema].task.map((activity, i) => {
			if (activity.id === idActivity) {
				idToNextOpen = i + 1;
				numberOfTaskCompleted++;
				return {
					...activity,
					pointsWon: pointsWin,
					isComplete: true,
				};
			} else {
				if (activity.pointsWon > 0) {
					numberOfTaskCompleted++;
				}
				return activity;
			}
		});
		// informacion actualizada
		if (activitiesInformationUpdated[idToNextOpen]) {
			activitiesInformationUpdated[idToNextOpen] = { ...activitiesInformationUpdated[idToNextOpen], isOpen: true };
		} else {
			// si no existe una actividad siguente entonces significa que abra el siguente subtema
			nextSubtemaOpen = state.menu.activitiesInformation[subtema].nextActivity;
		}

		if (nextSubtemaOpen !== "none") {
			if (state.menu.activitiesInformation[nextSubtemaOpen]) {
				dispatch(openNextSubtema({ next: nextSubtemaOpen, current: subtema }));
			}
		}

		dispatch(
			changeActivity({
				subtema,
				activitiesInformationUpdated,
				numberOfTaskCompleted,
			})
		);
	};
};
